import React, { memo } from 'react';

const Canonical = ({ links }) => {
    return (
      <>
            {links && links.length>0 && links.map((link) => {
        return <link rel="canonical" href={link.canonical} />
       })}  
    </>
    );
};

export default memo(Canonical);
